/**
 * Subscribe / one-time toggle for legacy-style cart forms in article recommended product tiles.
 */
(function () {
  if (window.__mjRecommendedPostsBuyButtonsInit) return;
  window.__mjRecommendedPostsBuyButtonsInit = true;

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest(
        '.recommended-posts-buy-buttons .choose-subscribe, .recommended-posts-buy-buttons .choose-onetime'
      );
      if (!toggle) return;

      const wrap = toggle.closest('.recommended-posts-buy-buttons');
      if (!wrap) return;

      event.preventDefault();

      const subBtn = wrap.querySelector('.choose-subscribe');
      const oneBtn = wrap.querySelector('.choose-onetime');
      const subForm = wrap.querySelector('form.subscribe-button');
      const oneForm = wrap.querySelector('form.one-time-button');

      if (toggle.classList.contains('choose-subscribe')) {
        subBtn?.classList.add('selected');
        oneBtn?.classList.remove('selected');
        subForm?.classList.remove('hidden');
        oneForm?.classList.add('hidden');
      } else {
        oneBtn?.classList.add('selected');
        subBtn?.classList.remove('selected');
        oneForm?.classList.remove('hidden');
        subForm?.classList.add('hidden');
      }
    },
    false
  );
})();
